
import { endPoints } from "../../constant/api_constants/url";
import { API_METHODS } from "../../enums";
import { fetchApi } from "../../utils/apiFunction";

export const getPromptAPI = async (accessJWT: string) => {
  const endpoint = endPoints.getPromptList;
  if (!accessJWT) return null;
  return await fetchApi(accessJWT, endpoint, API_METHODS.GET);
};


export const getPromptTemplateAPI = async (accessJWT: string) => {
  const endpoint = endPoints.getPromptTemplate;
  if (!accessJWT) return null;
  return await fetchApi(accessJWT, endpoint, API_METHODS.POST, { category: "ZENVOYA_APP" });
};
